const rubFormatter = new Intl.NumberFormat('ru-RU', {
	style: 'currency',
	currency: 'RUB',
	maximumFractionDigits: 0,
});

const dayFormatter = new Intl.NumberFormat('ru-RU', {
	maximumFractionDigits: 1,
});

const shortMillionFormatter = new Intl.NumberFormat('ru-RU', {
	maximumFractionDigits: 1,
});

const shortThousandFormatter = new Intl.NumberFormat('ru-RU', {
	maximumFractionDigits: 0,
});

export function formatRub(value: number): string {
	return rubFormatter.format(value);
}

export function formatSignedRub(value: number): string {
	return value < 0 ? `−${rubFormatter.format(Math.abs(value))}` : rubFormatter.format(value);
}

export function formatShortMoney(value: number): string {
	const abs = Math.abs(value);
	if (abs >= 1_000_000) {
		return t('format.million', {
			value: shortMillionFormatter.format(value / 1_000_000),
		});
	}
	if (abs >= 1000) {
		return t('format.thousand', { value: shortThousandFormatter.format(value / 1000) });
	}
	return shortThousandFormatter.format(value);
}

export function formatPaybackDays(days: number | null): string {
	if (days == null) return t('format.no-savings');
	return t('format.days', { value: dayFormatter.format(days) });
}

export function round1(n: number): number {
	return Math.round(n * 10) / 10;
}
import { TranslationNamespace } from '@/i18n';
import { getTranslated } from '@/i18n/get-translated';

const t = getTranslated(TranslationNamespace.Calculator);
